export function getTitle(notifications, person) {
  return `${person.first_name} ${person.last_name}'s notifications`
}
